(function() {
    'use strict';
    var controllerId = 'storesCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$http', storesCtrl]);

    function storesCtrl(common, datacontext, $scope, $http) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.orders = [];
        vm.title = 'Store List View';

        activate();

        function activate() {
            var promises = [
                get_store_dashboard()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    log('Activated ' + vm.title);
                });
        }

        function get_store_dashboard() {
            return datacontext.get_store_dashboard().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }
    }
})();

(function() {
    'use strict';
    var controllerId = 'storeDetailCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$http', storeDetailCtrl]);

    function storeDetailCtrl(common, datacontext, $scope, $http) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.orders = [];
        vm.title = 'Store Detail View';

        activate();

        function activate() {
            var promises = [
                get_stores(),
                get_marketplaces()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    log('Activated ' + vm.title);
                });
        }

        function get_stores() {
            return datacontext.get_stores().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }

        function get_marketplaces() {
            return datacontext.get_marketplaces().then(function(httpResult) {
                vm.marketplaces = httpResult.data.data;
            });
        }

    }
})();